export const anime: string[] = [
    "Naruto",
    "Dragon Ball Z"
];